(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s81-cart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    /* Same money helper as the PDP: prefer Shopify's formatter, fall back to ₺. */
    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      return '₺' + (cents / 100).toLocaleString('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    document.querySelectorAll('.s81-cart[data-section-id]').forEach((root) => {
      let busy = false;

      /* Push a new quantity for one line to Shopify and re-render totals live.
         quantity 0 removes the line (Shopify standard). */
      function changeLine(lineKey, quantity, lineEl) {
        if (busy) return;
        busy = true;
        root.classList.add('is-updating');

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: quantity }),
        })
          .then((r) => r.json())
          .then((cart) => {
            /* If the cart emptied, reload so the empty state renders. */
            if (cart.item_count === 0) {
              window.location.reload();
              return;
            }

            const line = cart.items.find((it) => it.key === lineKey);

            /* Quantity 0 (or line gone) → drop the row from the DOM. */
            if (!line || quantity === 0) {
              if (lineEl) lineEl.remove();
            } else if (lineEl) {
              const priceNow = lineEl.querySelector('.s81-cart__line-price-now');
              if (priceNow) priceNow.textContent = formatMoney(line.final_line_price);
              const input = lineEl.querySelector('[data-qty-input]');
              if (input) input.value = line.quantity;
            }

            /* Update every subtotal / total / count target. */
            const subtotal = formatMoney(cart.items_subtotal_price);
            const total = formatMoney(cart.total_price);

            root.querySelectorAll('.s81-cart__summary-val').forEach((el, i) => {
              if (i === 0) el.textContent = subtotal;
            });
            const headSub = root.querySelector('.s81-cart__head-right-sub');
            if (headSub) headSub.textContent = (root.dataset.tSubtotal || 'Ara toplam') + ' · ' + subtotal;
            const totalEl = root.querySelector('.s81-cart__summary-total');
            if (totalEl) totalEl.textContent = total;
            const checkoutPrice = root.querySelector('.s81-cart__checkout-price');
            if (checkoutPrice) checkoutPrice.textContent = total + ' →';

            const headCount = root.querySelector('.s81-cart__head-right > span');
            if (headCount) {
              var itemsLeftTpl = root.dataset.tItemsLeft || (cart.item_count + ' parça');
              headCount.textContent = itemsLeftTpl.replace('__COUNT__', cart.item_count);
            }
            document.querySelectorAll('[data-cart-count]').forEach((el) => {
              el.textContent = cart.item_count;
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          })
          .catch(() => {
            /* Network/parse failure — fall back to the native form update. */
            const form = root.querySelector('[data-cart-form]');
            if (form) form.submit();
          })
          .finally(() => {
            busy = false;
            root.classList.remove('is-updating');
          });
      }

      root.querySelectorAll('.s81-cart__line-qty').forEach((fieldset) => {
        const input = fieldset.querySelector('[data-qty-input]');
        const minus = fieldset.querySelector('[data-qty-minus]');
        const plus = fieldset.querySelector('[data-qty-plus]');
        if (!input) return;

        const lineEl = fieldset.closest('.s81-cart__line');
        const lineKey = lineEl ? lineEl.getAttribute('data-line-key') : null;

        function commit(qty) {
          const clamped = Math.max(0, qty);
          input.value = clamped;
          if (lineKey) changeLine(lineKey, clamped, lineEl);
        }

        if (minus) {
          minus.addEventListener('click', () => {
            commit((parseInt(input.value, 10) || 0) - 1);
          });
        }
        if (plus) {
          plus.addEventListener('click', () => {
            commit((parseInt(input.value, 10) || 0) + 1);
          });
        }
        /* Typed value: commit on change/blur. */
        input.addEventListener('change', () => {
          commit(parseInt(input.value, 10) || 0);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s81-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.s81-collection[data-section-id]').forEach((root) => {
      /* Auto-submit sort select on change */
      const sortSelect = root.querySelector('[data-sort-select]');
      const sortForm = root.querySelector('[data-sort-form]');
      if (sortSelect && sortForm) {
        sortSelect.addEventListener('change', () => {
          sortForm.submit();
        });
      }
    });

    document.addEventListener('click', (e) => {
      const sw = e.target.closest('.s81-collection__sw[data-sw-img]');
      if (!sw) return;
      const card = sw.closest('.s81-collection__card');
      const img = card && (card.querySelector('.s81-collection__shot-pic') || card.querySelector('.s81-collection__shot-img img'));
      if (!img) return;
      img.srcset = sw.dataset.swSrcset || '';
      img.src = sw.dataset.swImg;
      if (sw.dataset.swAlt) img.alt = sw.dataset.swAlt;
      card.querySelectorAll('.s81-collection__sw.is-active').forEach((el) => {
        el.classList.remove('is-active');
      });
      sw.classList.add('is-active');

      const wrap = card.querySelector('[data-gallery-images]');
      if (wrap) {
        const images = (wrap.dataset.galleryImages || '').split('~').filter(Boolean);
        const matchIdx = images.findIndex((u) => u.split('?')[0] === (sw.dataset.swImg || '').split('?')[0]);
        if (matchIdx >= 0) wrap.dataset.galleryIndex = matchIdx;
      }
    });

    /* ---- Card photo gallery: hover arrows + drag/swipe ---- */
    const slideCardImage = (wrap, img, newSrc, dir) => {
      const clone = img.cloneNode(true);
      clone.className = img.className;
      const cloneWrap = document.createElement('div');
      cloneWrap.className = 's81-collection__shot-slide-out';
      cloneWrap.appendChild(clone);
      wrap.appendChild(cloneWrap);

      img.style.transition = 'none';
      img.style.transform = 'translateX(' + (dir * 100) + '%)';
      img.removeAttribute('srcset');
      img.src = newSrc;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          img.style.transition = 'transform .32s ease';
          img.style.transform = 'translateX(0)';
          cloneWrap.style.transform = 'translateX(' + (-dir * 100) + '%)';
        });
      });
      setTimeout(() => {
        cloneWrap.remove();
        img.style.transition = '';
        img.style.transform = '';
      }, 400);
    };

    const galleryStep = (wrap, dir) => {
      const images = (wrap.dataset.galleryImages || '').split('~').filter(Boolean);
      if (images.length < 2) return;
      const colors = (wrap.dataset.galleryColors || '').split('~');
      const card = wrap.closest('.s81-collection__card');
      const img = wrap.querySelector('.s81-collection__shot-pic') || wrap.querySelector('img');
      if (!img) return;
      let idx = parseInt(wrap.dataset.galleryIndex || '0', 10);
      idx = ((idx + dir) % images.length + images.length) % images.length;
      wrap.dataset.galleryIndex = idx;
      slideCardImage(wrap, img, images[idx], dir);

      /* Kaydırılan fotoğraf farklı bir renge aitse, renk seçiciyi de o renge güncelle. */
      const newColor = colors[idx];
      if (card) {
        const swatches = card.querySelectorAll('.s81-collection__sw');
        if (newColor) {
          const targetSw = Array.from(swatches).find((sw) => sw.dataset.swColor === newColor);
          if (targetSw) {
            swatches.forEach((el) => el.classList.remove('is-active'));
            targetSw.classList.add('is-active');
          } else {
            swatches.forEach((el) => el.classList.remove('is-active'));
          }
        } else {
          swatches.forEach((el) => el.classList.remove('is-active'));
        }
      }
    };

    document.addEventListener('click', (e) => {
      const prevBtn = e.target.closest('[data-gallery-prev]');
      const nextBtn = e.target.closest('[data-gallery-next]');
      if (!prevBtn && !nextBtn) return;
      e.preventDefault();
      e.stopPropagation();
      const wrap = (prevBtn || nextBtn).parentElement.querySelector('[data-gallery-images]');
      if (wrap) galleryStep(wrap, prevBtn ? -1 : 1);
    });

    document.querySelectorAll('[data-gallery-images]').forEach((wrap) => {
      let startX = 0;
      let startY = 0;
      let dragging = false;
      let moved = false;

      wrap.addEventListener('pointerdown', (e) => {
        dragging = true;
        moved = false;
        startX = e.clientX;
        startY = e.clientY;
      });
      wrap.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        if (!moved && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) moved = true;
      });
      wrap.addEventListener('pointerup', (e) => {
        if (!dragging) return;
        dragging = false;
        if (moved) {
          const dx = e.clientX - startX;
          if (Math.abs(dx) > 30) galleryStep(wrap, dx < 0 ? 1 : -1);
        }
      });
      wrap.addEventListener('pointerleave', () => { dragging = false; });
      wrap.addEventListener('click', (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s81-featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var toastTimer;

    function showToast() {
      var toast = document.getElementById('s81-toast');
      if (!toast) return;
      clearTimeout(toastTimer);
      toast.classList.add('s81-toast--visible');
      toastTimer = setTimeout(function () {
        toast.classList.remove('s81-toast--visible');
      }, 2400);
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.s81-products__add-form');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () {
          showToast();
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          if (btn) btn.disabled = false;
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          form.submit();
        });
    });

    document.addEventListener('click', function (e) {
      var sw = e.target.closest('.s81-products__sw[data-sw-img]');
      if (!sw) return;
      var card = sw.closest('.s81-products__card');
      var img = card && (card.querySelector('.s81-products__shot-pic') || card.querySelector('.s81-products__shot-img img'));
      if (!img) return;
      img.srcset = sw.dataset.swSrcset || '';
      img.src = sw.dataset.swImg;
      if (sw.dataset.swAlt) img.alt = sw.dataset.swAlt;
      card.querySelectorAll('.s81-products__sw.is-active').forEach(function (el) {
        el.classList.remove('is-active');
      });
      sw.classList.add('is-active');

      var wrap = card.querySelector('[data-gallery-images]');
      if (wrap) {
        var images = (wrap.dataset.galleryImages || '').split('~').filter(Boolean);
        var matchIdx = images.findIndex(function (u) { return u.split('?')[0] === (sw.dataset.swImg || '').split('?')[0]; });
        if (matchIdx >= 0) wrap.dataset.galleryIndex = matchIdx;
      }
    });

    /* ---- Card photo gallery: hover arrows + drag/swipe ---- */
    function slideCardImage(wrap, img, newSrc, dir) {
      var clone = img.cloneNode(true);
      clone.className = img.className;
      var cloneWrap = document.createElement('div');
      cloneWrap.className = 's81-products__shot-slide-out';
      cloneWrap.appendChild(clone);
      wrap.appendChild(cloneWrap);

      img.style.transition = 'none';
      img.style.transform = 'translateX(' + (dir * 100) + '%)';
      img.removeAttribute('srcset');
      img.src = newSrc;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          img.style.transition = 'transform .32s ease';
          img.style.transform = 'translateX(0)';
          cloneWrap.style.transform = 'translateX(' + (-dir * 100) + '%)';
        });
      });
      setTimeout(function () {
        cloneWrap.remove();
        img.style.transition = '';
        img.style.transform = '';
      }, 400);
    }

    function galleryStep(wrap, dir) {
      var images = (wrap.dataset.galleryImages || '').split('~').filter(Boolean);
      if (images.length < 2) return;
      var colors = (wrap.dataset.galleryColors || '').split('~');
      var card = wrap.closest('.s81-products__card');
      var img = wrap.querySelector('.s81-products__shot-pic') || wrap.querySelector('img');
      if (!img) return;
      var idx = parseInt(wrap.dataset.galleryIndex || '0', 10);
      idx = ((idx + dir) % images.length + images.length) % images.length;
      wrap.dataset.galleryIndex = idx;
      slideCardImage(wrap, img, images[idx], dir);

      /* Kaydırılan fotoğraf farklı bir renge aitse, renk seçiciyi de o renge güncelle. */
      var newColor = colors[idx];
      if (card) {
        var swatches = card.querySelectorAll('.s81-products__sw');
        var targetSw = null;
        if (newColor) {
          targetSw = Array.from(swatches).find(function (sw) { return sw.dataset.swColor === newColor; });
        }
        swatches.forEach(function (el) { el.classList.remove('is-active'); });
        if (targetSw) targetSw.classList.add('is-active');
      }
    }

    document.addEventListener('click', function (e) {
      var prevBtn = e.target.closest('[data-gallery-prev]');
      var nextBtn = e.target.closest('[data-gallery-next]');
      if (!prevBtn && !nextBtn) return;
      e.preventDefault();
      e.stopPropagation();
      var wrap = (prevBtn || nextBtn).parentElement.querySelector('[data-gallery-images]');
      if (wrap) galleryStep(wrap, prevBtn ? -1 : 1);
    });

    document.querySelectorAll('[data-gallery-images]').forEach(function (wrap) {
      var startX = 0, startY = 0, dragging = false, moved = false;
      wrap.addEventListener('pointerdown', function (e) {
        dragging = true; moved = false; startX = e.clientX; startY = e.clientY;
      });
      wrap.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (!moved && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) moved = true;
      });
      wrap.addEventListener('pointerup', function (e) {
        if (!dragging) return;
        dragging = false;
        if (moved) {
          var dx = e.clientX - startX;
          if (Math.abs(dx) > 30) galleryStep(wrap, dx < 0 ? 1 : -1);
        }
      });
      wrap.addEventListener('pointerleave', function () { dragging = false; });
      wrap.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s81-header"]) return;
  try {
    
  document.addEventListener('cart:updated', (e) => {
    const count = e?.detail?.cart?.item_count;
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
    });
  });

  document.querySelectorAll('.s81-header__lang-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('is-active')) return;
      const form = btn.closest('form');
      const input = form.querySelector('[data-s81-lang-input]');
      input.value = btn.dataset.s81LangCode;
      form.submit();
    });
  });

  /* Mobile language dropdown trigger */
  document.querySelectorAll('[data-s81-lang-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const wrap = trigger.closest('.s81-header__lang');
      const isOpen = wrap.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.s81-header__lang.is-open').forEach((wrap) => {
      if (wrap.contains(e.target)) return;
      wrap.classList.remove('is-open');
      const trig = wrap.querySelector('[data-s81-lang-trigger]');
      if (trig) trig.setAttribute('aria-expanded', 'false');
    });
  });

  /* ── Mobile drawer (hamburger menu) ── */
  document.querySelectorAll('[data-s81-burger-open]').forEach((burger) => {
    const drawer = document.getElementById(burger.getAttribute('aria-controls'));
    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    burger.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-s81-burger-close]').forEach((btn) => {
      btn.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s81-member-admin"]) return;
  try {
    
  (function () {
    const ADMIN_TOKEN_KEY = 's81_admin_token';

    document.querySelectorAll('[data-s81-admin-root]').forEach((root) => {
      const baseUrl = (root.dataset.workerBaseUrl || '').replace(/\/+$/, '');
      const loginView = root.querySelector('[data-s81-admin-login]');
      const panelView = root.querySelector('[data-s81-admin-panel]');
      const loginForm = root.querySelector('[data-s81-admin-login-form]');
      const passwordInput = root.querySelector('[data-s81-admin-password-input]');
      const loginError = root.querySelector('[data-s81-admin-login-error]');
      const generateBtn = root.querySelector('[data-s81-admin-generate]');
      const genError = root.querySelector('[data-s81-admin-gen-error]');
      const resultEl = root.querySelector('[data-s81-admin-result]');
      const codeEl = root.querySelector('[data-s81-admin-code]');
      const copyBtn = root.querySelector('[data-s81-admin-copy]');
      const sendLink = root.querySelector('[data-s81-admin-send]');
      const historyEl = root.querySelector('[data-s81-admin-history]');
      const syncBtn = root.querySelector('[data-s81-admin-sync-prices]');
      const syncError = root.querySelector('[data-s81-admin-sync-error]');
      const syncResult = root.querySelector('[data-s81-admin-sync-result]');

      function showPanel() {
        loginView.hidden = true;
        panelView.hidden = false;
      }

      loginForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        loginError.hidden = true;
        try {
          const res = await fetch(baseUrl + '/admin/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ password: passwordInput.value })
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || !data.token) {
            loginError.textContent = 'Şifre hatalı.';
            loginError.hidden = false;
            return;
          }
          sessionStorage.setItem(ADMIN_TOKEN_KEY, data.token);
          showPanel();
        } catch (err) {
          loginError.textContent = 'Bağlantı hatası, tekrar deneyin.';
          loginError.hidden = false;
        }
      });

      generateBtn.addEventListener('click', async () => {
        genError.hidden = true;
        const token = sessionStorage.getItem(ADMIN_TOKEN_KEY);
        if (!token) { showLoginAgain(); return; }
        generateBtn.disabled = true;
        try {
          const res = await fetch(baseUrl + '/admin/generate-code', {
            method: 'POST',
            headers: { Authorization: 'Bearer ' + token }
          });
          if (res.status === 401) { showLoginAgain(); return; }
          const data = await res.json().catch(() => ({}));
          if (!res.ok || !data.code) {
            genError.textContent = 'Kod üretilemedi, tekrar deneyin.';
            genError.hidden = false;
            return;
          }
          codeEl.textContent = data.code;
          const waText = encodeURIComponent('Merhaba, üyelere özel giriş kodunuz: ' + data.code);
          sendLink.href = 'https://wa.me/?text=' + waText;
          resultEl.hidden = false;

          const li = document.createElement('li');
          const time = new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
          li.innerHTML = '<span>' + data.code + '</span><span>' + time + '</span>';
          historyEl.prepend(li);
        } catch (err) {
          genError.textContent = 'Bağlantı hatası, tekrar deneyin.';
          genError.hidden = false;
        } finally {
          generateBtn.disabled = false;
        }
      });

      syncBtn.addEventListener('click', async () => {
        syncError.hidden = true;
        syncResult.hidden = true;
        const token = sessionStorage.getItem(ADMIN_TOKEN_KEY);
        if (!token) { showLoginAgain(); return; }
        syncBtn.disabled = true;
        syncBtn.textContent = 'Güncelleniyor…';
        try {
          const res = await fetch(baseUrl + '/admin/sync-prices', {
            method: 'POST',
            headers: { Authorization: 'Bearer ' + token }
          });
          if (res.status === 401) { showLoginAgain(); return; }
          const data = await res.json().catch(() => ({}));
          if (!res.ok) {
            syncError.textContent = data.error || 'Güncellenemedi, tekrar deneyin.';
            syncError.hidden = false;
            return;
          }
          syncResult.textContent =
            'Kur: 1€ = ' + data.rate + ' TL\n' +
            'Yeni fiyat: ' + data.newPrice + ' TL\n' +
            'Kontrol edilen ürün: ' + data.productsChecked + '\n' +
            'Güncellenen ürün: ' + data.updatedProducts + ' (' + data.updatedVariants + ' varyant)';
          syncResult.hidden = false;
        } catch (err) {
          syncError.textContent = 'Bağlantı hatası, tekrar deneyin.';
          syncError.hidden = false;
        } finally {
          syncBtn.disabled = false;
          syncBtn.textContent = 'Fiyatları Şimdi Güncelle';
        }
      });

      copyBtn.addEventListener('click', () => {
        navigator.clipboard.writeText(codeEl.textContent).then(() => {
          copyBtn.textContent = 'Kopyalandı!';
          setTimeout(() => { copyBtn.textContent = 'Kodu Kopyala'; }, 1500);
        });
      });

      function showLoginAgain() {
        sessionStorage.removeItem(ADMIN_TOKEN_KEY);
        panelView.hidden = true;
        loginView.hidden = false;
        loginError.textContent = 'Oturum sona erdi, tekrar giriş yapın.';
        loginError.hidden = false;
      }

      if (sessionStorage.getItem(ADMIN_TOKEN_KEY)) {
        showPanel();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s81-member-panel"]) return;
  try {
    
  (function () {
    const COOKIE_NAME = 's81_member_session';

    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    }
    function setSessionCookie(token) {
      document.cookie = COOKIE_NAME + '=' + encodeURIComponent(token) + '; Max-Age=86400; Path=/; SameSite=Lax; Secure';
    }
    function clearSessionCookie() {
      document.cookie = COOKIE_NAME + '=; Max-Age=0; Path=/; SameSite=Lax; Secure';
    }

    document.querySelectorAll('[data-s81-member-root]').forEach((root) => {
      const baseUrl = (root.dataset.workerBaseUrl || '').replace(/\/+$/, '');
      const loginView = root.querySelector('[data-s81-member-login]');
      const areaView = root.querySelector('[data-s81-member-area]');
      const form = root.querySelector('[data-s81-member-form]');
      const codeInput = root.querySelector('[data-s81-member-code-input]');
      const submitBtn = root.querySelector('[data-s81-member-submit]');
      const errorEl = root.querySelector('[data-s81-member-error]');
      const logoutBtn = root.querySelector('[data-s81-member-logout]');
      const loadingEl = root.querySelector('[data-s81-member-loading]');
      const emptyEl = root.querySelector('[data-s81-member-empty]');
      const gridEl = root.querySelector('[data-s81-member-grid]');

      function showError(msg) {
        errorEl.textContent = msg;
        errorEl.hidden = false;
      }
      function hideError() {
        errorEl.hidden = true;
      }

      function showLoggedIn() {
        loginView.hidden = true;
        areaView.hidden = false;
      }
      function showLoggedOut() {
        areaView.hidden = true;
        loginView.hidden = false;
      }

      function money(amount, currency) {
        try {
          return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: currency || 'TRY' }).format(amount);
        } catch (e) {
          return amount + ' ' + (currency || '');
        }
      }

      function escapeHtml(s) {
        return String(s == null ? '' : s).replace(/"/g, '&quot;');
      }

      async function addToCart(card, product) {
        const select = card.querySelector('.s81-member-card__sizes');
        const addBtn = card.querySelector('.s81-member-card__add');
        const msgEl = card.querySelector('.s81-member-card__msg');
        const variantId = select.value;
        if (!variantId) return;

        msgEl.hidden = true;
        msgEl.className = 's81-member-card__msg';
        addBtn.disabled = true;
        addBtn.textContent = 'Ekleniyor…';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok) {
            msgEl.textContent = (data.description || 'Sepete eklenemedi.');
            msgEl.classList.add('is-error');
            msgEl.hidden = false;
            return;
          }
          msgEl.textContent = 'Sepete eklendi.';
          msgEl.classList.add('is-ok');
          msgEl.hidden = false;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: null } }));
          document.dispatchEvent(new CustomEvent('cart:update'));
        } catch (err) {
          msgEl.textContent = 'Bağlantı hatası, tekrar deneyin.';
          msgEl.classList.add('is-error');
          msgEl.hidden = false;
        } finally {
          addBtn.disabled = false;
          addBtn.textContent = 'Sepete Ekle';
        }
      }

      function renderProducts(products) {
        gridEl.innerHTML = '';
        if (!products || !products.length) {
          emptyEl.hidden = false;
          return;
        }
        emptyEl.hidden = true;
        products.forEach((p) => {
          const card = document.createElement('div');
          card.className = 's81-member-card';

          const thumbs = [
            { key: 'front', label: 'Ön', url: p.images && p.images.front },
            { key: 'back', label: 'Arka', url: p.images && p.images.back },
            { key: 'sides', label: 'Yan', url: p.images && p.images.sides }
          ].filter((t) => t.url);

          const availableVariants = (p.variants || []).filter((v) => v.available);
          const sizeOptions = (p.variants || [])
            .map((v) => '<option value="' + v.variantId + '"' + (v.available ? '' : ' disabled') + '>' + v.size + (v.available ? '' : ' (tükendi)') + '</option>')
            .join('');

          card.innerHTML =
            '<div class="s81-member-card__main">' +
              (thumbs[0] ? '<img src="' + thumbs[0].url + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
            '</div>' +
            '<div class="s81-member-card__thumbs">' +
              thumbs.map((t, i) => (
                '<div class="s81-member-card__thumb' + (i === 0 ? ' is-active' : '') + '" data-thumb="' + t.key + '" data-img="' + t.url + '">' +
                  '<img src="' + t.url + '" alt="' + escapeHtml(p.title) + ' - ' + t.label + '" loading="lazy">' +
                '</div>'
              )).join('') +
            '</div>' +
            '<div class="s81-member-card__body">' +
              '<h3 class="s81-member-card__title"></h3>' +
              '<p class="s81-member-card__price"></p>' +
              '<p class="s81-member-card__price-note">Ödeme anında güncel kurla ₺ olarak tahsil edilir.</p>' +
              '<div class="s81-member-card__row">' +
                '<select class="s81-member-card__sizes" ' + (availableVariants.length ? '' : 'disabled') + '>' +
                  (availableVariants.length ? sizeOptions : '<option>Tükendi</option>') +
                '</select>' +
                '<button type="button" class="s81-member-card__add"' + (availableVariants.length ? '' : ' disabled') + '>Sepete Ekle</button>' +
              '</div>' +
              '<p class="s81-member-card__msg" hidden></p>' +
            '</div>';

          card.querySelector('.s81-member-card__title').textContent = p.title;
          const firstAvailable = availableVariants[0];
          card.querySelector('.s81-member-card__price').textContent = firstAvailable ? '25 €' : '';

          const mainImg = card.querySelector('.s81-member-card__main img');
          card.querySelectorAll('.s81-member-card__thumb').forEach((thumbEl) => {
            thumbEl.addEventListener('click', () => {
              card.querySelectorAll('.s81-member-card__thumb').forEach((el) => el.classList.remove('is-active'));
              thumbEl.classList.add('is-active');
              if (mainImg) mainImg.src = thumbEl.dataset.img;
            });
          });

          if (availableVariants.length) {
            card.querySelector('.s81-member-card__add').addEventListener('click', () => addToCart(card, p));
          }

          gridEl.appendChild(card);
        });
      }

      async function loadMemberProducts(token) {
        loadingEl.hidden = false;
        emptyEl.hidden = true;
        gridEl.innerHTML = '';
        try {
          const res = await fetch(baseUrl + '/member-products', {
            headers: { Authorization: 'Bearer ' + token }
          });
          if (res.status === 401) {
            clearSessionCookie();
            showLoggedOut();
            showError('Oturumunuzun süresi doldu, lütfen tekrar giriş yapın.');
            return;
          }
          if (!res.ok) throw new Error('request failed');
          const data = await res.json();
          renderProducts(data.products || []);
        } catch (e) {
          loadingEl.hidden = true;
          emptyEl.hidden = false;
          emptyEl.textContent = 'Ürünler yüklenemedi, lütfen sayfayı yenileyin.';
        } finally {
          loadingEl.hidden = true;
        }
      }

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        hideError();
        const code = codeInput.value.trim().toUpperCase();
        if (!code) return;
        submitBtn.disabled = true;
        try {
          const res = await fetch(baseUrl + '/redeem', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code: code })
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || !data.token) {
            showError(data.error || 'Kod geçersiz veya daha önce kullanılmış.');
            return;
          }
          setSessionCookie(data.token);
          showLoggedIn();
          loadMemberProducts(data.token);
        } catch (err) {
          showError('Bir şeyler ters gitti, tekrar deneyin.');
        } finally {
          submitBtn.disabled = false;
        }
      });

      logoutBtn.addEventListener('click', () => {
        clearSessionCookie();
        showLoggedOut();
      });

      const existingToken = getCookie(COOKIE_NAME);
      if (existingToken) {
        showLoggedIn();
        loadMemberProducts(existingToken);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s81-pdp-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.s81-pdp[data-section-id]').forEach((root) => {
      let productData = {};
      try {
        productData = JSON.parse(root.dataset.productJson || '{}');
      } catch (_) {
        productData = {};
      }

      const stageImg = root.querySelector('[data-stage-img]');
      const stageFrame = root.querySelector('[data-stage-frame]');
      const stageMedia = root.querySelector('.s81-pdp__stage-media');

      /* Nav-arrow vertical position is derived from the page's INITIAL aspect
         ratio only (captured once, never updated) so the buttons never jump
         when switching between portrait/landscape photos. */
      const baseStageRatio = parseFloat(stageFrame && stageFrame.style.aspectRatio) || 0.8;

      /* Slide the stage photo out/in (instead of an instant swap) so browsing
         images reads as a left/right pan, matching the drag gesture direction. */
      const slideStage = (newSrc, newAlt, direction) => {
        if (!stageMedia || !stageImg || !newSrc) return;
        const cloneWrap = document.createElement('div');
        cloneWrap.className = 's81-pdp__stage-slide-out';
        cloneWrap.appendChild(stageImg.cloneNode(true));
        stageMedia.appendChild(cloneWrap);

        stageImg.style.transition = 'none';
        stageImg.style.transform = 'translateX(' + (direction * 100) + '%)';
        stageImg.removeAttribute('srcset');
        stageImg.src = newSrc;
        if (newAlt) stageImg.alt = newAlt;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            stageImg.style.transition = 'transform .32s ease';
            stageImg.style.transform = 'translateX(0)';
            cloneWrap.style.transform = 'translateX(' + (-direction * 100) + '%)';
          });
        });
        setTimeout(() => {
          cloneWrap.remove();
          stageImg.style.transition = '';
          stageImg.style.transform = '';
        }, 400);
      };

      const form = root.querySelector('form[data-product-form]');
      const variantInput = form ? form.querySelector('[data-variant-id]') : null;
      const priceEl = root.querySelector('[data-price]');
      const comparePriceEl = root.querySelector('[data-compare-price]');
      const addPriceEl = root.querySelector('[data-add-price]');
      const skuEl = root.querySelector('[data-sku]');
      const skuTagEl = root.querySelector('[data-sku-tag]');
      const addBtn = root.querySelector('[data-add-btn]');
      const addLabel = root.querySelector('[data-add-label]');
      const buyNowBtn = form ? form.querySelector('button[name="checkout"]') : null;
      const variantOptionsTag = root.querySelector('[data-variant-options]');

      const optionCount = (productData.options && productData.options.length) || 0;
      const initialVariant = (productData.variants || []).find((v) => String(v.id) === String(variantInput && variantInput.value));
      const selectedOptions = initialVariant && initialVariant.options ? initialVariant.options.slice() : new Array(optionCount).fill(null);

      /* Size must be chosen explicitly — clear any pre-filled size option so the
         customer cannot add to cart before picking a size. (A4 audit fix) */
      const sizeIndexes = Array.from(
        new Set(
          Array.from(root.querySelectorAll('[data-is-size="true"]'))
            .map((b) => parseInt(b.dataset.optionIndex, 10))
            .filter((n) => !isNaN(n))
        )
      );
      sizeIndexes.forEach((i) => { selectedOptions[i] = null; });
      const sizeMissing = () => sizeIndexes.some((i) => !selectedOptions[i]);

      /* ---- Thumbnails ---- */
      const thumbs = root.querySelectorAll('.s81-pdp__thumb');
      const thumbsArr = Array.from(thumbs);
      const stageDots = Array.from(root.querySelectorAll('.s81-pdp__dot'));
      const colorOptionIndex = parseInt(root.dataset.colorOptionIndex, 10);

      /* When a thumb click is itself the result of the color-swatch sync below
         re-selecting a variant, suppress the resulting image jump-back so the
         stage stays on the photo the user actually swiped/clicked to. */
      let suppressImageSync = false;

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const src = thumb.dataset.stageSrc;
          const alt = thumb.dataset.stageAlt;
          const ratio = thumb.dataset.stageRatio;
          if (stageImg && src) {
            const currentSrc = (stageImg.getAttribute('src') || '').split('?')[0];
            if (src.split('?')[0] !== currentSrc) {
              const prevIdx = thumbsArr.findIndex((t) => t.classList.contains('is-active'));
              const newIdx = thumbsArr.indexOf(thumb);
              const direction = (prevIdx < 0 || newIdx >= prevIdx) ? 1 : -1;
              slideStage(src, alt, direction);
            }
          }
          if (stageFrame && ratio) stageFrame.style.aspectRatio = ratio;
          thumbs.forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');

          const activeThumbIdx = thumbsArr.indexOf(thumb);
          stageDots.forEach((d, i) => d.classList.toggle('is-on', i === activeThumbIdx));

          /* Kaydırılan fotoğraf farklı bir renge aitse, renk seçiciyi de o renge güncelle. */
          const thumbColor = thumb.dataset.stageColor;
          if (
            !isNaN(colorOptionIndex) &&
            colorOptionIndex >= 0 &&
            thumbColor &&
            selectedOptions[colorOptionIndex] !== thumbColor
          ) {
            const colorSwatches = root.querySelectorAll('[data-option-index="' + colorOptionIndex + '"]');
            const targetSwatch = Array.from(colorSwatches).find((sw) => sw.dataset.optionValue === thumbColor);
            if (targetSwatch && !targetSwatch.classList.contains('is-oos') && !targetSwatch.disabled) {
              suppressImageSync = true;
              targetSwatch.click();
              suppressImageSync = false;
            }
          }
        });
      });

      /* ---- Stage prev/next arrows + drag-to-swipe ---- */
      const thumbList = Array.from(thumbs);
      const stepStage = (dir) => {
        if (thumbList.length < 2) return;
        const activeIdx = thumbList.findIndex((t) => t.classList.contains('is-active'));
        const nextIdx = (((activeIdx < 0 ? 0 : activeIdx) + dir) % thumbList.length + thumbList.length) % thumbList.length;
        thumbList[nextIdx].click();
      };
      const stagePrevBtn = root.querySelector('[data-stage-prev]');
      const stageNextBtn = root.querySelector('[data-stage-next]');
      if (stagePrevBtn) stagePrevBtn.addEventListener('click', () => stepStage(-1));
      if (stageNextBtn) stageNextBtn.addEventListener('click', () => stepStage(1));

      /* Pin the nav arrows to a constant vertical position (based on the
         frame's initial ratio + current width only) so they don't jump when
         photos of a different orientation slide in. */
      const setStageNavPosition = () => {
        if (!stageFrame || (!stagePrevBtn && !stageNextBtn)) return;
        const w = stageFrame.getBoundingClientRect().width;
        const topPx = (w / baseStageRatio) / 2;
        if (stagePrevBtn) stagePrevBtn.style.top = topPx + 'px';
        if (stageNextBtn) stageNextBtn.style.top = topPx + 'px';
      };
      setStageNavPosition();
      window.addEventListener('resize', setStageNavPosition);

      if (stageMedia && thumbList.length > 1) {
        let dragStartX = 0;
        let dragStartY = 0;
        let isDragging = false;
        let dragMoved = false;

        stageMedia.addEventListener('pointerdown', (e) => {
          isDragging = true;
          dragMoved = false;
          dragStartX = e.clientX;
          dragStartY = e.clientY;
        });
        stageMedia.addEventListener('pointermove', (e) => {
          if (!isDragging) return;
          const dx = e.clientX - dragStartX;
          const dy = e.clientY - dragStartY;
          if (!dragMoved && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
            dragMoved = true;
          }
        });
        const endDrag = (e) => {
          if (!isDragging) return;
          isDragging = false;
          if (dragMoved) {
            const dx = e.clientX - dragStartX;
            if (Math.abs(dx) > 40) stepStage(dx < 0 ? 1 : -1);
          }
        };
        stageMedia.addEventListener('pointerup', endDrag);
        stageMedia.addEventListener('pointerleave', () => { isDragging = false; });
        /* Swipe shouldn't also trigger the zoom-open click on the stage image itself. */
        stageMedia.addEventListener('click', (e) => {
          if (dragMoved) {
            e.preventDefault();
            e.stopPropagation();
            dragMoved = false;
          }
        }, true);
      }

      /* Varyant görseline geçerken eşleşen thumbnail varsa onun üzerinden git
         (aktiflik durumu + 1200w src); yoksa ham varyant görselini bas. */
      const syncStageImage = (fimg) => {
        if (suppressImageSync) return;
        if (!fimg || !fimg.src || !stageImg) return;
        const base = fimg.src.split('?')[0];
        let matchedThumb = null;
        thumbs.forEach((t) => {
          if ((t.dataset.stageSrc || '').split('?')[0] === base) matchedThumb = t;
        });
        if (matchedThumb) {
          matchedThumb.click();
        } else {
          slideStage(fimg.src, null, 1);
          if (stageFrame && fimg.width && fimg.height) {
            stageFrame.style.aspectRatio = (fimg.width / fimg.height).toString();
          }
        }
      };

      /* ---- Money helper ---- */
      const formatMoney = (cents) => {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents);
        }
        const n = (cents / 100).toFixed(2);
        return '₺' + n;
      };

      /* ---- Variant selection ---- */
      const updateForVariant = (variant) => {
        if (!variant) {
          if (addBtn) addBtn.disabled = true;
          if (buyNowBtn) buyNowBtn.disabled = true;
          if (addLabel) addLabel.textContent = sizeMissing() ? (root.dataset.sizePrompt || 'Beden Seçin') : (root.dataset.tNoOption || 'Seçenek Yok');
          return;
        }
        if (variantInput) variantInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (addPriceEl) addPriceEl.textContent = formatMoney(variant.price) + ' →';

        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = formatMoney(variant.compare_at_price);
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }

        if (skuEl) skuEl.textContent = 'SKU ' + (variant.sku || '—');
        if (skuTagEl) skuTagEl.textContent = (root.dataset.tSeries || 'SERİ') + ' · ' + (variant.sku || 'S81');

        if (variantOptionsTag && variant.title && variant.title !== 'Default Title') {
          variantOptionsTag.textContent = variant.title.toLocaleUpperCase('tr');
        }

        if (addBtn) addBtn.disabled = !variant.available;
        if (buyNowBtn) buyNowBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? (root.dataset.tAddToCart || 'Sepete Ekle') : (root.dataset.tSoldOut || 'Tükendi');

        syncStageImage(variant.featured_image);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      };

      const findVariant = () => {
        if (!productData.variants) return null;
        /* If a size option exists but hasn't been chosen, there is no valid variant yet. */
        if (sizeMissing()) return null;
        return productData.variants.find((v) => {
          if (!v.options) return false;
          for (let i = 0; i < selectedOptions.length; i++) {
            if (selectedOptions[i] && v.options[i] !== selectedOptions[i]) return false;
          }
          return true;
        });
      };

      /* A size (or colour) button can look available in isolation while the
         SPECIFIC combination with the currently selected other option(s) has
         no stock — e.g. 6XL exists and sells fine in black, but there is no
         6XL/white variant at all. Recompute every button's real availability
         against the *current* selection instead of trusting the initial,
         color-agnostic server render. */
      const refreshOptionAvailability = () => {
        root.querySelectorAll('[data-option-index]').forEach((btn) => {
          const idx = parseInt(btn.dataset.optionIndex, 10);
          const val = btn.dataset.optionValue;
          const hasMatch = (productData.variants || []).some((v) => {
            if (!v.options || !v.available) return false;
            if (v.options[idx] !== val) return false;
            for (let i = 0; i < selectedOptions.length; i++) {
              if (i === idx) continue;
              if (selectedOptions[i] && v.options[i] !== selectedOptions[i]) return false;
            }
            return true;
          });
          btn.classList.toggle('is-oos', !hasMatch);
          btn.disabled = !hasMatch;
          btn.setAttribute('aria-disabled', hasMatch ? 'false' : 'true');
        });
      };
      refreshOptionAvailability();

      root.querySelectorAll('[data-option-index]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.classList.contains('is-oos') || btn.disabled) return;
          const idx = parseInt(btn.dataset.optionIndex, 10);
          const val = btn.dataset.optionValue;
          selectedOptions[idx] = val;
          refreshOptionAvailability();

          root.querySelectorAll('[data-option-index="' + idx + '"]').forEach((sib) => {
            sib.classList.remove('is-active');
            sib.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');

          const display = root.querySelector('[data-option-display="' + idx + '"]');
          if (display) display.textContent = val;

          const variant = findVariant();
          updateForVariant(variant);

          /* Beden seçilmeden renk değiştirilirse tam varyant oluşmaz ama görsel
             ve seçenek etiketi yine de yeni renge geçmeli. Beden yok sayılarak
             seçili renge uyan ilk varyantın görseli kullanılır. */
          if (!variant) {
            const partialMatch = (productData.variants || []).find((v) => {
              if (!v.options) return false;
              for (let i = 0; i < selectedOptions.length; i++) {
                if (sizeIndexes.indexOf(i) !== -1) continue;
                if (selectedOptions[i] && v.options[i] !== selectedOptions[i]) return false;
              }
              return true;
            });
            if (partialMatch) syncStageImage(partialMatch.featured_image);
            if (variantOptionsTag) {
              const partialLabel = selectedOptions
                .map((o, i) => o || (sizeIndexes.indexOf(i) !== -1 ? '—' : ''))
                .filter(Boolean);
              if (partialLabel.length) variantOptionsTag.textContent = partialLabel.join(' / ').toLocaleUpperCase('tr');
            }
          }
        });
      });

      /* Apply initial state: if a size is required but not chosen, the button
         starts as a disabled "Beden Seçin" prompt instead of silently adding. */
      if (sizeIndexes.length) {
        updateForVariant(findVariant());
      }

      /* ---- Qty stepper ---- */
      const qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
      const qtyMinus = root.querySelector('[data-qty-minus]');
      const qtyPlus = root.querySelector('[data-qty-plus]');
      if (qtyMinus && qtyInput) {
        qtyMinus.addEventListener('click', () => {
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        });
      }
      if (qtyPlus && qtyInput) {
        qtyPlus.addEventListener('click', () => {
          qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
        });
      }

      /* ---- AJAX add-to-cart ---- */
      if (form) {
        form.addEventListener('submit', async (e) => {
          if (e.submitter && e.submitter.name === 'checkout') {
            return; /* native buy-now submit */
          }
          e.preventDefault();
          if (!addBtn || addBtn.disabled) return;
          const originalLabel = addLabel ? addLabel.textContent : '';
          if (addLabel) addLabel.textContent = 'Ekleniyor…';
          addBtn.disabled = true;

          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: new URLSearchParams(new FormData(form)).toString(),
            });
            if (!res.ok) throw new Error('add failed');

            if (addLabel) addLabel.textContent = root.dataset.tAdded || '✓ Sepete Eklendi';

            /* Show the global cart toast (same element the header/featured sections use) */
            const toastEl = document.getElementById('s81-toast');
            if (toastEl) {
              toastEl.classList.add('s81-toast--visible');
              clearTimeout(window.__s81ToastTimer);
              window.__s81ToastTimer = setTimeout(() => {
                toastEl.classList.remove('s81-toast--visible');
              }, 2400);
            }

            setTimeout(() => {
              if (addLabel) addLabel.textContent = originalLabel || root.dataset.tAddToCart || 'Sepete Ekle';
              addBtn.disabled = false;
            }, 1800);

            try {
              const cartRes = await fetch('/cart.js');
              const cart = await cartRes.json();
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            } catch (_) { /* swallow */ }
          } catch (err) {
            if (addLabel) addLabel.textContent = root.dataset.tErrorRetry || 'Hata — Tekrar dene';
            setTimeout(() => {
              if (addLabel) addLabel.textContent = originalLabel || root.dataset.tAddToCart || 'Sepete Ekle';
              addBtn.disabled = false;
            }, 1800);
          }
        });
      }

      /* ---- Zoom button (placeholder; lightbox deferred) ---- */
      const zoomBtn = root.querySelector('[data-zoom]');
      if (zoomBtn && stageImg) {
        zoomBtn.addEventListener('click', () => {
          if (stageImg.src) window.open(stageImg.src, '_blank', 'noopener');
        });
      }
    });
  });

  /* ── Size guide ── */
  (function () {
    var guide = document.getElementById('s81-size-guide');
    if (!guide) return;

    function openGuide() {
      guide.classList.add('is-open');
      guide.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeGuide() {
      guide.classList.remove('is-open');
      guide.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('.s81-pdp__opt-help').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openGuide(); });
    });

    guide.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-guide-close]')) closeGuide();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && guide.classList.contains('is-open')) closeGuide();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s81-pdp-paired"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript && document.currentScript.closest
      ? document.currentScript.closest('[data-products-recommendations]')
      : null;

    if (!root) {
      root = document.querySelector('[data-products-recommendations]:not([data-hydrated])');
    }
    if (!root) return;

    var source = root.querySelector('[data-paired-grid]');
    if (!source) return;
    var src = source.getAttribute('data-paired-source');
    if (src === 'recommendations' || src === 'design-collection') {
      root.setAttribute('data-hydrated', 'true');
      return;
    }

    var url = root.getAttribute('data-url');
    if (!url) return;

    root.setAttribute('data-hydrated', 'pending');

    fetch(url)
      .then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-paired-grid]');
        if (incoming && incoming.children.length > 0) {
          source.innerHTML = incoming.innerHTML;
          source.setAttribute('data-paired-source', 'recommendations');
        }
        root.setAttribute('data-hydrated', 'true');
      })
      .catch(function () {
        root.setAttribute('data-hydrated', 'error');
      });
  })();

  } catch(e) { console.error(e); }
})();
})();
